module.exports = __webpack_public_path__ + "files/75a6b2e83a9018c8fb567c77e612f55a.svg";